import React, {useCallback, useContext, useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { AssistantContext } from "./AssistantContext";
import AssistantLoader from "../../components/assistant/AssistantLoader";
import {BlueButton, GreenButton} from "../buttons/ButtonStyles";
import ExitButton from "../../components/buttons/ExitButton";
import ai from "../../images/artificial-intelligence.svg";
import CoachEnjoyIcon from "../../images/coachEnjoyNoBgNoTitle.png";
import idea from "../../images/give_idea.svg";
import useAssistant from "./useAssistant";
import styled from "styled-components";
import AddButton from "../buttons/AddButton";
import ShareWithTeam from "../modal/ShareWithTeam";

const Assistant = ({ context, size = "normal", onSelect, fromCoach, setClose, adjust, swotCoach}) => {
  const { useAssistant: useAssistantFlag } = useSelector(
      (state) => state.strategy
  );

  const { requestSuggestion } = useAssistant();

  const { setCache, getCache, updateCache } = useContext(AssistantContext);

  const [state, setState] = useState({
    loading: false,
    error: false,
    open: false,
    items: [],
  });

  const [lengthError, setLengthError] = useState(false);
  const [comment, setComment] = useState(adjust ?? "");
  const finalComment = comment?.trim().length > 0 ? `Prends en compte cette proposition d'ajustement "${comment}" pour affiner ta réponse.` : ""
  //const finalComment = comment?.trim().length > 0 ? `Avant de répondre prends en compte cet ajustement :" ${comment} ", si l'ajustement n'est pas du tout en lien avec un contexte professionnel, ne réponds pas et retourne uniquement cette phrase : "Désolé mais votre ajustement ne semble pas être en lien avec le contexte de réponse".` : ""
  const [share, setShare] = useState(false);
  const handleChangeComment = (e) => {
    setComment(e.target.value);
  }
  useEffect(() => {
    if(fromCoach){
      request({comment: finalComment})
      setClose(false)
    }
  }, []);

  useEffect(() => {
    setComment(adjust)
  },[updateCache, adjust])

  const exit = useCallback(() => {
    setState((prev) => ({
      ...prev,
      open: false,
      error: false,
      loading: false,
      items: [],
    }));
    if(fromCoach){
      setClose(true)
    }
  }, []);
  const request = useCallback(
      (options) => {
        setState((prev) => ({
          ...prev,
          open: true,
          loading: true,
          error: false,
          items: [],
        }));
        const cache = getCache(context);
        if (cache && !options?.nocache && cache.length > 0) {
          setState((prev) => ({
            ...prev,
            loading: false,
            items: cache,
          }));
        } else {
          requestSuggestion(context, options?.comment)
              .then((data) => {
                setState((prev) => ({
                  ...prev,
                  loading: false,
                  items: data,
                }));
                setCache(context, data);
              })
              .catch(() => {
                setState((prev) => ({
                  ...prev,
                  error: true,
                  loading: false,
                }));
              });
        }
      },
      [setCache, context, getCache, requestSuggestion]
  );
  const getTitleLabel = useCallback(() => {
    switch (context.object) {
      case "axis_analysis":
        return `Voici une analyse concernant l'axe ${context.axis}`;
      case "project_analysis":
        return `Voici une analyse concernant le projet ${context.project}`;
      case "axis":
        return "Voici des propositions pour vous inspirer des axes stratégiques pour votre organisation";
      case "stake":
        return `Voici des propositions pour vous inspirer des enjeux pour l'axe ${context.axis}`;
      case "project":
        return `Voici des propositions pour vous inspirer des projets pour l'enjeu ${context.stake}`;
      case "improveAxis":
        return `Voici des propositions pour vous inspirer des projets pour l'enjeu ${context.stake}`;
      case "improveProject":
        return `Voici des propositions pour d'améliorations pour le projet ${context.project}`;
      case "idea":
        return `Voici des propositions pour vous inspirer des idées pour le projet ${context.project}`;
      case "objective":
        return `Voici des propositions pour vous inspirer des objectifs pour le projet" ${context.project}`;
      case "indicator":
        return `Voici des propositions pour vous inspirer des indicateurs pour l'objectif" ${context.objective}`;
      case "action":
        return `Voici des propositions pour vous inspirer des actions pour le projet" ${context.project}`;
      case "swot":
        return `Voici des propositions pour vous inspirer des ${
            context.type
        }s pour le Swot pour votre ${
            context.entity === "axis" ? "axe" : "projet"
        } ${context.entityName}`;
      case "success":
        return "Voici des propositions de valeurs pour votre organisation";
      case "vision":
        return "Voici des propositions de  visions pour votre organisation";
      case "goal":
        return "Voici des propositions d'ambitions pour votre organisation";
      case "duty":
        return "Voici des propositions de missions pour votre organisation";

      default:
        return "";
    }
  }, [
    context.axis,
    context.entity,
    context.entityName,
    context.object,
    context.objective,
    context.project,
    context.stake,
    context.type,
  ]);

  return (
      <>
        {
            !fromCoach &&

            <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 24,
                }}
                onClick={request}
            >
              <CoachEnjoyLogo size={size} swotCoach={swotCoach}/>
            </div>
        }

        {state.open && (
            <>
              <div
                  style={ !fromCoach ?{
                    zIndex: 1,
                    width: "100vw",
                    height: "100vh",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    background: "rgba(0,0,0,0.5)",
                  } : {}}
              />
              <div
                  style={ !fromCoach ? {
                    boxShadow: "1px 1px 5px rgba(0,0,0,0.25)",
                    zIndex: 2,
                    padding: 24,
                    opacity: 1,
                    borderRadius: 8,
                    position: "fixed",
                    backgroundColor: "white",
                    width: "60vw",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  } : {}}
              >
                {!useAssistantFlag && (
                    <div>
                      <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                      >
                        <div />
                        {
                            !fromCoach &&
                            <>
                              <CoachEnjoyLogo />
                              <ExitButton closeUpdate={exit} />
                            </>
                        }
                      </div>
                      <div
                          style={{
                            display: "flex",
                            marginTop: 24,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                      >
                        <div>
                          <h2>
                            Cette fonction n'a pas été activée dans votre abonnement.
                          </h2>
                          <h2>Rapprochez vous si besoin de votre administrateur</h2>
                        </div>
                      </div>
                    </div>
                )}
                {useAssistantFlag && state.error && (
                    <div>
                      <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 24,
                          }}
                      >
                        <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                        >
                          <h1>Coach Enjoy </h1>
                          <img
                              src={CoachEnjoyIcon}
                              alt="choisir une proprosition"
                              width={48}
                              height={48}
                          />
                        </div>
                        <ExitButton closeUpdate={exit} />
                      </div>

                      <h2>
                        Nous sommes désolés mais nous avons rencontré un problème
                      </h2>
                      <ButtonBlock>
                        <RerunButton rerun={() => request({ nocache: true })} />
                      </ButtonBlock>
                    </div>
                )}
                {useAssistantFlag && state.items.length !== 0 && !state.loading && (
                    <div>
                      {
                          !fromCoach &&
                          <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: 24,
                              }}
                          >
                            <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                            >
                              <h1>Coach Enjoy</h1>

                              <img
                                  src={CoachEnjoyIcon}
                                  alt="choisir une proprosition"
                                  width={48}
                                  height={48}
                              />
                            </div>

                            <ExitButton closeUpdate={exit}/>
                          </div>
                      }

                      <h2 style={{color: "gray"}}>{getTitleLabel()}</h2>
                      {
                          lengthError && context.object === "action" &&
                          <div style={{
                            padding: "1rem",
                            border: "1px solid red",
                            color: "red",
                            borderRadius: "15px",
                            textAlign: "center"
                          }}>
                            Le titre de cette action est trop long.
                          </div>
                      }
                      <br/>

                      <ResponseContainer style={{ maxHeight: fromCoach ? "45vh" : "50vh"}}>
                        {state.items.map((item, index) => (
                            <div
                                key={item.name}
                                style={{
                                  cursor: "pointer",
                                  border: "0.5px solid grey",
                                  borderRadius: 4,
                                  padding: 12,
                                  marginBottom: 8,
                                }}
                                onClick={() => {
                                  if (onSelect && item.name.length < 255) {
                                    exit();
                                    updateCache(context, index);
                                    onSelect(item);
                                    setLengthError(false)
                                  }
                                  if(!onSelect && fromCoach){
                                    setClose(true)
                                  }
                                  else {
                                    setLengthError(true)
                                  }
                                }}
                            >
                              <div style={{ display: "flex", gap: 8}}>
                                {onSelect && (
                                    <img src={idea} alt="choisir une proprosition" />
                                )}
                                <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 1,
                                    }}
                                >
                                  <h3>{item.name}</h3>
                                  {item.description.split("\n").map((d) => (
                                      <p style={{ textAlign: "left" }}>{d}</p>
                                  ))}
                                </div>
                              </div>
                            </div>
                        ))}
                      </ResponseContainer>
                      {
                          !fromCoach &&
                          <CommentBlock>
                            <h2> Besoin de précision ?</h2>
                            <input type="text" value={comment} onChange={handleChangeComment}/>
                          </CommentBlock>
                      }
                      <ButtonBlock>
                        <RerunButton rerun={() => request({ nocache: true, comment: finalComment})} />
                        {
                            /*
                            *
                            * (context.object === "axis_analysis" || context.object === "project_analysis") &&
                            <>
                              <BlueButton
                                  style={{ padding: 12, color: "white", fontSize: 16 }}
                                  onClick={() => {setShare(true)}}
                              >
                                <p>Partager</p>
                              </BlueButton>
                              {
                                  share &&
                                  <ShareWithTeam preparedText={state.items[0].description} setIsOpenShareWithModal={setShare} context={context.object} />
                              }
                            </>
                            * */
                        }
                      </ButtonBlock>
                    </div>
                )}
                {useAssistantFlag && state.loading && (
                    <div>
                      <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                      >
                        <ExitButton closeUpdate={exit} />
                      </div>
                      <AssistantLoader />
                    </div>
                )}
              </div>
            </>
        )}
      </>
  );
};

const CoachEnjoyLogo = ({ size, swotCoach}) => {
  const getSize = useCallback(() => {
    switch (size) {
      case "small":
        return 24;
      case "tiny":
        return 36;
      default:
        return 48;
    }
  }, [size]);

  return (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        <>
          <img
              src={CoachEnjoyIcon}
              alt="Besoin du coach Enjoy ?"
              width={getSize()}
              height={getSize()}
          />

          {
              swotCoach ??
              <>
                {size === "normal" && <h2> &nbsp; Besoin du coach Enjoy ?</h2>}
                {size === "small" && <p> &nbsp; Coach ?</p>}
              </>
          }
        </>
      </div>
  );
};

const RerunButton = ({ rerun }) => {
  return (
        <GreenButton
            style={{ padding: 24, color: "white", fontSize: 16 }}
            onClick={rerun}
        >
          Relancer l'inspiration
        </GreenButton>
  );
};
const ButtonBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-top: 24px
`
const CommentBlock = styled.div`
  margin-top: 2rem;
  input[type=text]{
    width: 100%;
    height: 30px;
    font-size: 16px;
    padding: 1rem;
    background-color: #eee;
    border: none;
    border-bottom: 2px solid var(--color-purple);
  }
`

const ResponseContainer = styled.div`
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  ::-webkit-scrollbar-thumb {
    width: 6px;
    border-radius: 10px;
    background-color: transparent;
  }
  :hover::-webkit-scrollbar-thumb{
    background-color: var(--color-purple);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  }

`

export default Assistant;
